import classnames from 'classnames';
import React from 'react';

import { IRecommendedRatios, recommendedRatios } from './config';
import styles from './index.module.less';

interface RecommendedRatiosProps {
  onSelect: (width: number, height: number) => void;
}

const RecommendedRatiosComponent: React.FC<RecommendedRatiosProps> = ({ onSelect }) => {
  const [active, setActive] = React.useState(0);

  const handleSelect = (item: IRecommendedRatios, index: number) => {
    onSelect(item.width, item.height);
    setActive(index);
  };

  return (
    <div className={styles.container}>
      {recommendedRatios.map((item, index) => {
        const selected = active === index;
        return (
          <div
            key={index}
            className={classnames(styles.recommendedRatio, { [styles.active]: selected })}
            onClick={() => handleSelect(item, index)}
          >
            <div className={styles.ratioContainer} style={{ ...item?.mask }}>
            </div>
            <div className={styles.ratioInfo}>
              <div className={styles.ratioText}>{item.ratio}</div>
              <div className={styles.ratioType}>{item.type}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RecommendedRatiosComponent;
